module.exports = __webpack_public_path__ + "static/media/login-logo.5f322e74.png";